export const SET_BUTTON_DISABLED = 'SET_BUTTON_DISABLED';

export const setButtonDisabled = (isDisabled: boolean) => ({
  type: SET_BUTTON_DISABLED,
  payload: isDisabled,
});
